import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'
import { useSelector } from 'react-redux'
import { isRequiredFieldRegistrazione } from '../../../utils/servicegift'

export function getValidationSchema(tipologiaUtenteChiave, social) {
  const t = useTrans()
  const service_gift = useSelector((state) => state?.servicegift?.service_gift)

  const withRequired = (chiave, yupObject) => {
    if (isRequiredFieldRegistrazione(service_gift, tipologiaUtenteChiave, chiave)) {
      return yupObject?.type == 'boolean'
        ? yupObject.oneOf([true])
        : yupObject.required(t('Questo campo è obbligatorio')).nullable()
    }

    return yupObject.nullable()
  }

  return yup.object({
    utente: yup
      .object({
        nome: withRequired('utente.nome', yup.string()),
        cognome: withRequired('utente.cognome', yup.string()),
        // email: withRequired('utente.email', yup.string().email(t("L'email deve essere valida"))),
        telefono: withRequired(
          'utente.telefono',
          yup.string().min(8, t('Minimo {0} caratteri', [8]))
        ),
        // cod_fiscale: withRequired('utente.cod_fiscale', yup.string()),
        username: yup
          .string()
          .email("L'email deve essere valida")
          .required(t('Questo campo è obbligatorio'))
          .nullable(),
        password: social
          ? yup.string().nullable()
          : yup
              .string()
              .label('Password')
              .required(t('Questo campo è obbligatorio'))
              .min(6, t('Minimo {0} caratteri', [6]))
              .nullable(),
        conferma_password: social
          ? yup.string().nullable()
          : yup
              .string()
              .required(t('Questo campo è obbligatorio'))
              .label(t('Conferma Password'))
              .test('passwords-match', t('Le due password dovrebbero coincidere'), function (
                value
              ) {
                return this.parent.password === value
              })
              .nullable(),
      })
      .required(),
    dati_indirizzo: yup.object().when('is_fatturazione_italia', {
      is: true,
      then: yup.object({
        nome: withRequired('indirizzo_fatturazione.nome', yup.string()),
        cognome: withRequired('indirizzo_fatturazione.cognome', yup.string()),
        ragione_sociale: withRequired('indirizzo_fatturazione.ragione_sociale', yup.string()),
        email: withRequired(
          'indirizzo_fatturazione.email',
          yup.string().email(t("L'email deve essere valida"))
        ),
        telefono: withRequired(
          'indirizzo_fatturazione.telefono',
          yup.string().min(8, t('Minimo {0} caratteri', [8]))
        ),
        partita_iva: withRequired(
          'indirizzo_fatturazione.partita_iva',
          yup.string().max(11, t('Massimo {0} caratteri', [11]))
        ),
        indirizzo: withRequired(
          'indirizzo_fatturazione.indirizzo',
          yup.string().max(35, t('Troppo lungo'))
        ),
        cap: withRequired(
          'indirizzo_fatturazione.cap',
          yup.string().min(5, t('Minimo {0} caratteri', [5]))
        ),
        citta: withRequired('indirizzo_fatturazione.citta', yup.string()),
        nazione_id: withRequired('indirizzo_fatturazione.nazione', yup.string()),
        provincia: withRequired('indirizzo_fatturazione.provincia', yup.string()),
        cod_fiscale: withRequired('indirizzo_fatturazione.cod_fiscale', yup.string()),
        sdi: withRequired('indirizzo_fatturazione.sdi', yup.string()),
        pec: withRequired(
          'indirizzo_fatturazione.pec',
          yup.string().email(t('La pec deve essere valida'))
        ),
      }),
      otherwise: yup.object({
        nome: withRequired('indirizzo_fatturazione.nome', yup.string()),
        cognome: withRequired('indirizzo_fatturazione.cognome', yup.string()),
        ragione_sociale: withRequired('indirizzo_fatturazione.ragione_sociale', yup.string()),
        email: withRequired(
          'indirizzo_fatturazione.email',
          yup.string().email(t("L'email deve essere valida"))
        ),
        telefono: withRequired(
          'indirizzo_fatturazione.telefono',
          yup.string().min(8, t('Minimo {0} caratteri', [8]))
        ),
        partita_iva: withRequired(
          'indirizzo_fatturazione.partita_iva',
          yup.string().max(11, t('Massimo {0} caratteri', [11]))
        ),
        indirizzo: withRequired(
          'indirizzo_fatturazione.indirizzo',
          yup.string().max(35, t('Troppo lungo'))
        ),
        cap: withRequired(
          'indirizzo_fatturazione.cap',
          yup.string().min(5, t('Minimo {0} caratteri', [5]))
        ),
        citta: withRequired('indirizzo_fatturazione.citta', yup.string()),
        nazione_id: withRequired('indirizzo_fatturazione.nazione', yup.string()),
        provincia: yup.string().nullable(),
        cod_fiscale: withRequired('indirizzo_fatturazione.cod_fiscale', yup.string()),
        sdi: yup.string().nullable(),
        pec: yup.string().email(t('La pec deve essere valida')).nullable(),
      }),
    }),
    dati_indirizzo_spedizione: yup.object().when('indirizzi_diversi', {
      is: true,
      then: yup.object().when('is_spedizione_italia', {
        is: true,
        then: yup.object({
          nome: withRequired('indirizzo_spedizione.nome', yup.string()),
          cognome: withRequired('indirizzo_spedizione.cognome', yup.string()),
          ragione_sociale: withRequired('indirizzo_spedizione.ragione_sociale', yup.string()),
          email: withRequired(
            'indirizzo_spedizione.email',
            yup.string().email(t("L'email deve essere valida"))
          ),
          telefono: withRequired(
            'indirizzo_spedizione.telefono',
            yup.string().min(8, t('Minimo {0} caratteri', [8]))
          ),
          partita_iva: withRequired(
            'indirizzo_spedizione.partita_iva',
            yup.string().max(11, t('Massimo {0} caratteri', [11]))
          ),
          indirizzo: withRequired(
            'indirizzo_spedizione.indirizzo',
            yup.string().max(35, t('Troppo lungo'))
          ),
          cap: withRequired(
            'indirizzo_spedizione.cap',
            yup.string().min(5, t('Minimo {0} caratteri', [5]))
          ),
          citta: withRequired('indirizzo_spedizione.citta', yup.string()),
          nazione_id: withRequired('indirizzo_spedizione.nazione', yup.string()),
          provincia: withRequired('indirizzo_spedizione.provincia', yup.string()),
          cod_fiscale: withRequired('indirizzo_spedizione.cod_fiscale', yup.string()),
          sdi: withRequired('indirizzo_spedizione.sdi', yup.string()),
          pec: withRequired(
            'indirizzo_spedizione.pec',
            yup.string().email(t('La pec deve essere valida'))
          ),
        }),
        otherwise: yup.object({
          nome: withRequired('indirizzo_spedizione.nome', yup.string()),
          cognome: withRequired('indirizzo_spedizione.cognome', yup.string()),
          ragione_sociale: withRequired('indirizzo_spedizione.ragione_sociale', yup.string()),
          email: withRequired(
            'indirizzo_spedizione.email',
            yup.string().email(t("L'email deve essere valida"))
          ),
          telefono: withRequired(
            'indirizzo_spedizione.telefono',
            yup.string().min(8, t('Minimo {0} caratteri', [8]))
          ),
          partita_iva: withRequired(
            'indirizzo_spedizione.partita_iva',
            yup.string().max(11, t('Massimo {0} caratteri', [11]))
          ),
          indirizzo: withRequired(
            'indirizzo_spedizione.indirizzo',
            yup.string().max(35, t('Troppo lungo'))
          ),
          cap: withRequired(
            'indirizzo_spedizione.cap',
            yup.string().min(5, t('Minimo {0} caratteri', [5]))
          ),
          citta: withRequired('indirizzo_spedizione.citta', yup.string()),
          nazione_id: withRequired('indirizzo_spedizione.nazione', yup.string()),
          provincia: yup.string().nullable(),
          cod_fiscale: withRequired('indirizzo_spedizione.cod_fiscale', yup.string()),
          sdi: yup.string().nullable(),
          pec: yup.string().email(t('La pec deve essere valida')).nullable(),
        }),
      }),
      otherwise: yup.object().nullable(),
    }),
    autorizzazioni: yup.object({
      privacy_commerciale: withRequired('utente.autorizzazioni_consensi', yup.bool()),
    }),
  })
}
